import { render, staticRenderFns } from "./linkedMerchant.vue?vue&type=template&id=701e51b8&scoped=true"
import script from "./linkedMerchant.vue?vue&type=script&lang=js"
export * from "./linkedMerchant.vue?vue&type=script&lang=js"
import style0 from "./linkedMerchant.vue?vue&type=style&index=0&id=701e51b8&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701e51b8",
  null
  
)

export default component.exports